<template>
    <div class="content2-box">
        <div class="title">
            <img src="@/assets/home/intergral-title-icon2.png" alt="">
            <div class="text">创新积分应用</div>
            <img src="@/assets/home/intergral-title-icon1.png" alt="">
        </div>
        <div class="content">
            <div class="con-box">
                <div class="item" @click="goMore('/finance/index')">
                    <div class="tit">科技金融   <img src="@/assets/home/right-jiantou.png" alt=""></div>
                    <div class="text">推动创新创业活动，增创发展新优势，集成式服务。以需求为引导、企业为主体、市场为导向、产学研深度融合的技术创新体系，加速科技成果转化，推动产业转型升级。
                    </div>
                </div>
                <div class="item" @click="goMore('/integral/pyku','企业培育库')">
                    <div class="tit">企业培育库   <img src="@/assets/home/right-jiantou.png" alt=""></div>
                    <div class="text">精准遴选目标，加强入库企业精准对接、培育辅导，助推科技型企业提档升级。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "index",
	data() {
		return {

		}
	},
	mounted() {

	},
	methods: {
        goMore(url, key, id) {
            this.$router.push({
                path: url,
                query: { type: key, queryData: id }
            })
        },

	}
}
</script>

<style scoped lang="less">
.content2-box{
    width: 1200px;
    margin:40px auto 40px auto;
    .content{
        .con-box{
            display: flex;
            justify-content: space-between;
            .item{
                width: 49%;
                background: url("../../../assets/home/cxjfyy-img1.png");
                background-size: 100% 100%;
                color:#fff;
                height: 300px;
                padding:40px 30px 0 30px;
                cursor: pointer;
                box-sizing: border-box;
                .tit{
                    font-weight: 400;
                    font-size: 22px;
                    color: #FFFFFF;
                    line-height: 50px;
                    position: relative;
                    &::before{
                        content:'';
                        display: block;
                        width: 60px;
                        height: 4px;
                        background: linear-gradient(0deg, #3F67FF, #55A2F9);
                        border-radius: 2px;
                        position: absolute;
                        top:60px;
                    }
                    img{
                        width: 22px;
                        height: 22px;
                        margin-left: 4px;
                    }
                }
                .text{
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 32px;
                    padding:40px 0;
                }
            }
            .item:last-child{
                background: url("../../../assets/home/cxjfyy-img2.png");
                background-size: 100% 100%;
            }
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        font-size: 40px;
        color: #0F2555;
        line-height: 24px;
        padding:40px 0;
        img{
            width: 461px;
            height: 17px;
        }
    }
}
</style>
